import React, {
    useLayoutEffect,
    useRef,
    useMemo
} from 'react';
import { Link, useLocation } from 'react-router-dom';

import config from "../config/config";

const campaign_name_spektrix = config.ATTRIBUTES?.DonationUpsellCampaignName;
const ticketDonations = config.OPTION_FIELDS.donation_campaign?.find( donation => donation.spektrix_attribute_name === campaign_name_spektrix);
const instanceId = config.INSTANCE?.iframe_id;

const pathList = [
    {
        key: 'select-seats',
        name: 'Select tickets',
        show: true,
        path: `/book-online/${instanceId}`,
    },
    {
        key: 'ticket-donations',
        name: 'Donation',
        show: !!ticketDonations && campaign_name_spektrix,
        path: `/book-online/${instanceId}/ticket-donations`,
    },
    {
        key: 'extras',
        name: 'Extras',
        show: !!config.SUPPLEMENTARY_INSTANCES,
        path: `/book-online/${instanceId}/extras`,
    },
    {
        key: 'basket',
        name: 'Basket',
        show: true,
        path: `/basket`,
    },
    {
        key: 'checkout',
        name: 'Checkout',
        show: true,
        path: `/checkout`,
    },
]

export default function Breadcrumbs(props) {
    const { pathname } = useLocation();
    const pathnameArray = pathname.split("/");
    const pathName = pathnameArray[pathnameArray.length - 1];

    const currentIndex = pathList.findIndex(i => {
        if (Number.isFinite(Number(pathName)) && i.key == 'select-seats') {
            return i;
        }
        if( i.key === pathName) {
            return i;
        }
    })

    
    const activeClass = (path) => {
        if(Number.isFinite(Number(pathName)) && path == 'select-seats') {
            return true
        }

        if (pathName == path) {
            return true
        }

        return false
    }

    if(!instanceId) return;

    return(
        <nav className='type-h5 breadcrumbs'>
            <ul>
                {
                    pathList.map( (path, index) => 
                        path.show && <li className={activeClass(path.key) ? 'active' : ''} key={path.key}>
                            {currentIndex > index ? 
                                <Link to={path.path}>{path.name}</Link>                                
                                :
                                <span>{path.name}</span>
                            }
                        </li>
                    )
                    // Object.entries(pathList).map(([key, value], i) =>
                    //     <li className={activeClass(key) ? 'active' : ''} key={key}>{value}</li>
                    // )
                }
            </ul>
        </nav>
    )

}